import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Billing } from '@classes/billing';
import { BillingService } from 'app/core/services/billing.service';
import { UiService } from 'app/core/services/ui.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import * as _moment from 'moment';
import { MatExpansionPanel } from '@angular/material/expansion';
import { TranslateService } from '@ngx-translate/core';
import { IndexService } from 'app/core/services/index.service';
import { BillActionModel } from '@classes/bill-action-model';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MatDialog } from '@angular/material/dialog';
import { MessageBox } from '@components/message-box/message-box.component';
import { BillingType } from '@enums/billing-type.enum';
import { SelectionModel } from '@angular/cdk/collections';
const moment = _moment;

@Component({
  selector: 'app-billing-done',
  templateUrl: './billing-done.component.html',
  styleUrls: ['./billing-done.component.scss'],
  styles: [`
  >>> app-billing-done {
    height: 100%;
  }
`]
})
export class BillingDoneComponent implements OnInit {

  dataSource = new MatTableDataSource<Billing>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'select',
    'billingType',
    'year',
    'month',
    'reference',
    'site',
    'company',
    'deadlineDate',
    'isExceptional',
    // 'paymentDate',
    // 'reminderDate',
    'tva',
    'totalHtva',
    'totalTva',
    'totalTtc',
    'isValide',
    'sendDate',
    'action'
  ];

  selection = new SelectionModel<Billing>(true, []);

  billingDoneGridFilterForm: FormGroup;
  filterLabel = "";

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("billingDoneFilterExpansionPanel", { static: true }) expansionPanel: MatExpansionPanel;

  BillingType = BillingType;

  constructor(
    private formBuilder: FormBuilder,
    public uiService: UiService,
    private billingService: BillingService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public dialog: MatDialog,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'site': return (element.site?.name);
        case 'company': return (element.company?.name);
        case 'month': return (element.month);
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.getUrlParam();
    this.onFilter();
  }


  getUrlParam() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 1) {
      const value = this.route.snapshot.queryParams;
      let param: any = {
        month: []
      };
      if (value.month != null) {
        if (typeof value.month == "string") {
          param.month = [value.month];
        } else if (typeof value.month == "object") {
          param.month = value.month;
        }
      }
      if (value.isExceptional != null) {
        param.isExceptional = value.isExceptional;
      }
      if (value.billingType != null) {
        param.billingType = value.billingType;
      }
      if (value.companyId != null) {
        param.companyId = value.companyId;
        param.companyName = value.companyName;
      }
      if (value.siteId != null) {
        param.siteId = value.siteId;
        param.siteName = value.siteName;
      }
      if (value.reference != null) {
        param.reference = value.reference;
      }
      if (value.year != null) {
        param.year = value.year;
      }
      else {
        param.year = moment().get("year");
      }
      this.initFilterForm(param);
    } else {
      this.initFilterForm();
    }
  }

  private initFilterForm(filter?: any) {
    const fb = this.formBuilder;
    this.billingDoneGridFilterForm = fb.group({
      billingType: fb.control((filter && filter.billingType != null) ? filter.billingType : 0),
      site: fb.control((filter && filter.siteId != null) ? { id: filter.siteId, name: filter.siteName } : null),
      company: fb.control((filter && filter.companyId != null) ? { id: filter.companyId, name: filter.companyName } : null),
      year: fb.control((filter && filter.year != null) ? filter.year : null),
      month: fb.control((filter && filter.month != null) ? filter.month : []),
      reference: fb.control((filter && filter.reference != null) ? filter.reference : null),
      isExceptional: fb.control((filter && filter.isExceptional != null) ? filter.reference : ""),
    });
  }
  private setFilterFormUrl() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 1) {
      const value = this.billingDoneGridFilterForm.value;
      const formatUrlParam = (value: any): object => {
        let param: any = {};
        param.selectedTab = this.route.snapshot.queryParams.selectedTab || 1;
        if (value.billingType != null) {
          param.billingType = value.billingType;
        }
        if (value.company != null) {
          param.companyId = value.company.id;
          param.companyName = value.company.name;
        }
        if (value.site != null) {
          param.siteId = value.site.id;
          param.siteName = value.site.name;
        }
        if (value.reference != null) {
          param.reference = value.reference;
        }
        if (value.year != null) {
          param.year = value.year;
        }
        if (value.month != null) {
          param.month = value.month;
        }
        if (value.isExceptional != "") {
          param.isExceptional = value.isExceptional;
        }
        return param;
      }

      const queryParams = formatUrlParam(value);
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams
        }
      ).toString();
      this.location.go(url);
      this.route.snapshot.queryParams = queryParams;
    }
  }

  getBillings() {
    this.uiService.addRouteLoading();
    const filterValue = this.billingDoneGridFilterForm.value;
    this.billingService.getBillings(
      filterValue.year,
      filterValue.month
    ).subscribe(data => {
      this.selection.clear();
      this.dataSource.data = data;
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    }, () => {
      this.uiService.removeRouteLoading();
    });
  }

  selectItemClick(element: Billing) {
    this.selectedRowID = element.id || '';
  }

  onDownload(element: Billing) {
    this.uiService.addRouteLoading();
    this.billingService.downloadBillingDoc((element.docId || 0).toString()).subscribe(data => {
      this.uiService.removeRouteLoading();
      this.billingService.downloadBlobFile(data);
    }, error => {
      this.uiService.removeRouteLoading();
      console.error(error);
    })
  }
  createFilter(): (data: Billing, filter: string) => boolean {
    let filterFunction = function (data: Billing,
      filter: string
    ): boolean {
      let searchTerms = JSON.parse(filter);
      let mapQuarter = (billing: Billing, months: number[]): boolean => {
        if (billing.billingType != BillingType.Concession)
          return months.includes(billing.month || -1);
        switch (billing.quarter) {
          case 1:
            return (months.includes(1) || months.includes(2) || months.includes(3));
          case 2:
            return (months.includes(4) || months.includes(5) || months.includes(6));
          case 3:
            return (months.includes(7) || months.includes(8) || months.includes(8));
          case 4:
            return (months.includes(10) || months.includes(11) || months.includes(12));
        }
        return true;
      }
      const filterValue =
        ((typeof searchTerms.site == "object" && searchTerms.site) ? data.siteId == searchTerms.site.id : true)
        && ((typeof searchTerms.company == "object" && searchTerms.company) ? data.companyId == searchTerms.company.id : true)
        && ((searchTerms.billingType != null && searchTerms.billingType != 0) ? data.billingType == searchTerms.billingType : true)
        && (searchTerms.year != null ? data.year == searchTerms.year : true)
        && ((searchTerms.month != null && searchTerms.month.length > 0) ? mapQuarter(data, searchTerms.month.map((m: string) => parseInt(m))) : true)
        && (searchTerms.reference != null ? data.reference?.includes(searchTerms.reference) : true)
        && (searchTerms.isExceptional != "" ? data.isExceptional == (searchTerms.isExceptional == "true") : true)
        ;
      return <boolean>filterValue;
    }
    return filterFunction;
  }



  onFilter() {
    this.dataSource.filter = JSON.stringify(this.billingDoneGridFilterForm.value);
    this.initFilterLabel();
    this.setFilterFormUrl();
    this.expansionPanel.close();
    this.getBillings();
  }
  onClearFilter() {
    this.initFilterForm();
    this.initFilterLabel();
    this.onFilter();
    this.setFilterFormUrl();
    this.getBillings();
  }

  initFilterLabel() {
    this.filterLabel = "";
    const addSeparator = () => {
      if (this.filterLabel.length > 0) {
        this.filterLabel += " | "
      }
    }
    const filterValue = this.billingDoneGridFilterForm.value;
    if (filterValue.billingType) {
      addSeparator();
      this.filterLabel += ("Type : " + this.translateService.instant("label.billing-type-" + filterValue.billingType));
    }
    if (filterValue.year) {
      addSeparator();
      this.filterLabel += ("Année : " + filterValue.year);
    }
    if (filterValue.month && filterValue.month.length > 0) {
      addSeparator();
      this.filterLabel += ("Mois : " + filterValue.month.map((element: string) => {
        return this.translateService.instant("label.month-" + element)
      }).join(", "));
    }
    if (filterValue.reference) {
      addSeparator();
      this.filterLabel += ("Référence : " + filterValue.reference);
    }
    if (typeof filterValue.site == "object" && filterValue.site) {
      addSeparator();
      this.filterLabel += ("Site : " + filterValue.site.name);
    }
    if (typeof filterValue.company == "object" && filterValue.company) {
      addSeparator();
      this.filterLabel += ("Société : " + filterValue.company.name);
    }
    if (filterValue.isExceptional != "") {
      addSeparator();
      this.filterLabel += ("Convoi exceptionnel : " + (filterValue.isExceptional == "true" ? "Oui" : "Non"));
    }
  }

  onCancelBilling(element: Billing) {
    const messageBoxParameter: MessageBoxParameter = {
      message: this.translateService.instant('billing.confirm-cancel'),
      dialog: this.dialog,
      title: 'Confirmation',
      buttons: ['yes', 'no'],
      width: "400px"
    };
    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        let model = new BillActionModel();
        model.billingIds = [element.id || ""];
        this.billingService.cancelBilling(model).subscribe(data => {
          this.getBillings();
        }, error => {
          console.error(error);
        });
      }
    });
  }


  onValideBilling(element: Billing) {
    this.valideBilling([element.id || ""]);
  }
  onValideSelectedBilling() {
    this.valideBilling(<Array<string>>this.selection.selected.map(m => m.id));
  }
  private valideBilling(value: Array<string>) {
    const messageBoxParameter: MessageBoxParameter = {
      message: this.translateService.instant(value.length > 1 ? 'billing.confirm-validate-multiple' : 'billing.confirm-validate'),
      dialog: this.dialog,
      title: 'Confirmation',
      buttons: ['yes', 'no'],
      width: "400px"
    };
    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        let model = new BillActionModel();
        model.billingIds = value;
        this.billingService.validateBilling(model).subscribe(data => {
          this.selection.clear();
          this.getBillings();
        }, error => {
          console.error(error);
        });
      }
    });
  }


  onSendMail(element: Billing) {
    this.sendMail([element.id || ""]);
  }
  onSendSelectedMail() {
    this.sendMail(<Array<string>>this.selection.selected.map(m => m.id));
  }

  private sendMail(value: Array<string>) {
    const messageBoxParameter: MessageBoxParameter = {
      message: this.translateService.instant(value.length > 1 ? 'billing.confirm-sendMail-multiple' : 'billing.confirm-sendMail'),
      dialog: this.dialog,
      title: 'Confirmation',
      buttons: ['yes', 'no'],
      width: "400px"
    };
    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        let model = new BillActionModel();
        model.billingIds = value;
        model.validate = true;
        this.billingService.sendMailBilling(model).subscribe(data => {
          this.selection.clear();
          this.getBillings();
        }, error => {
          console.error(error);
        });
      }
    });
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }

}
